import { React, useState, useEffect } from "react";
import SellBanner from "../../assets/images/car-inspection/car-inspection-banner.jpg";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import axios from 'axios';
import { BASE_IMAGE_URL, BASE_URL } from '../../config';
import { Markup } from 'interweave';
import { toast } from "react-toastify";
import { Link, useNavigate, useParams } from "react-router-dom";
import sellCar1 from '../../assets/images/sell-car-1.webp';
import sellCar2 from '../../assets/images/sell-car-2.png';
import sellCar3 from '../../assets/images/sell-car-3.webp';

function SellCarRanchi({ isShowLoader }) {
  let [data, setData] = useState([]);
  const { slug } = useParams();


  let fetchData = async () => {
    try {
      await axios.get(`${BASE_URL}/get-car-sell/${slug}`)
        .then(res => {
          if (res.data.responseCode === 200) {
            console.log(res.data.responseData);
            setData(res.data.responseData);


          }
          isShowLoader(false);
        })
    } catch (error) {
      console.log(error);

    }
  }

  useEffect(() => {
    fetchData();
    isShowLoader(true);
    // setTimeout(() => {
    //   isShowLoader(false);
    // }, 1000);
  }, [slug]);
  return (
    <div className="mainbodycls">
      <section className="sub-banner">
        <div className="carouselinner">

          <OwlCarousel
            class="owl-carousel owl-theme"
            loop
            margin={0}
            nav={false}
            dots={true}
            items={1}
            autoplay={true}
            autoplaySpeed={1200}
          >
            <div className="item">
              <img src={SellBanner} alt="" />
            </div>
          </OwlCarousel>

          <div class="subbannertext">
            <div className="container">
              <h1>Sell Car in <span className="bluee">{data.city_name}</span></h1>
              <div className="bredcam">
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li>Sell Car {data.city_name}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="urgntrequire usetopbtom sellacartopbanner sellcarinner">
        <div className="container">
          <div className="row sellcarrow align-items-center">
            <div className="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-12">
              <div
                class=""
                dangerouslySetInnerHTML={{
                  __html: data.sell_car ? data.sell_car : "",
                }}
              ></div>
            </div>
            <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-12">
              <div class="sellcarpic">
                <img src={sellCar1} loading="lazy" alt="" />
              </div>
            </div>
          </div>
          <div className="row sellcarrow align-items-center">
            <div className="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-12">
              <div
                class=""
                dangerouslySetInnerHTML={{
                  __html: data.why_choose ? data.why_choose : "",
                }}
              ></div>
            </div>
            <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-12">
              <div class="sellcarpic">
                <img src={sellCar2} loading="lazy" alt="" />
              </div>
            </div>
          </div>
          <div className="row sellcarrow align-items-center">
            <div className="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-12">
              <div
                class=""
                dangerouslySetInnerHTML={{
                  __html: data.sell_pre_owned ? data.sell_pre_owned : "",
                }}
              ></div>

            </div>
            <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-12">
              <div class="sellcarpic">
                <img src={sellCar3} loading="lazy" alt="" />
              </div>
            </div>
          </div>
          <div className="row justify-content-between">
            <div
              class=""
              dangerouslySetInnerHTML={{
                __html: data.trusted_used ? data.trusted_used : "",
              }}
            ></div>

          </div>
        </div>
      </section>
    </div>
  )
}

export default SellCarRanchi